import { useMemo } from 'react';
import { useFetchUserInfo } from './useFetchUserInfo';
export const useUserTeams = () => {
  const userInfoResult = useFetchUserInfo();
  return useMemo(() => Object.assign({}, userInfoResult, {
    data: userInfoResult.data && userInfoResult.data.userInfo.user.teams
  }), [userInfoResult]);
};